/** @format */

export const exclusiveBrands = ['Nike', 'Gold'];

export const footwearApparelAttrNames = [
	'color',
	'shoesize',
	'shoewidth',
	'size',
	'inseam',
	'length'
];

export const partyAttributes = {
	nike: 'nike_connected',
	gold: 'gold'
};

export const exclusiveCTATypes = {
	nike: {
		loggedIn: 'connectAccounts',
		notLoggedIn: 'signIn'
	},
	gold: {
		loggedIn: 'locked',
		notLoggedIn: 'lockedSignIn'
	}
};

export const exclusiveApeValue = {
	nike: 'Nike APE Exclusive',
	gold: 'Gold APE Exclusive'
};

export const partyAttrText = 'partyAttributes';
